import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { label: 'Funcionalidades', href: '#features' },
    { label: 'Screenshots', href: '#screenshots' },
    { label: 'Depoimentos', href: '#testimonials' },
    { label: 'FAQ', href: '#faq' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-slate-100" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <a href="/site" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src="/logo.png"
              alt="DRE+ Logo"
              className="w-12 h-12 rounded-full object-contain"
              style={{
                filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 1)) drop-shadow(0 0 16px rgba(255, 255, 255, 0.8)) drop-shadow(0 0 24px rgba(255, 255, 255, 0.6))',
                background: 'white',
                padding: '2px'
              }}
            />
            <span className="font-heading font-bold text-xl text-[#0F172A]">Controle Financeiro</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="nav-link text-sm"
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button Desktop */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="https://app.dremais.com.br"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-cta-btn"
            >
              <Button className="bg-[#047857] hover:bg-[#065F46] text-white rounded-full px-6 py-2 font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/25">
                Começar Agora
                <ChevronRight className="w-4 h-4 ml-1" />
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-[#0F172A]" />
            ) : (
              <Menu className="w-6 h-6 text-[#0F172A]" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
            className="lg:hidden absolute top-full left-4 right-4 mt-2 mobile-menu p-6"
            data-testid="mobile-menu"
          >
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-[#0F172A] font-medium py-2 hover:text-[#047857] transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </a>
              ))}
              <a
                href="https://app.dremais.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4"
                data-testid="mobile-cta-btn"
              >
                <Button className="w-full bg-[#047857] hover:bg-[#065F46] text-white rounded-full py-3 font-semibold">
                  Começar Agora
                  <ChevronRight className="w-4 h-4 ml-1" />
                </Button>
              </a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
